/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { Button, Icon, SurveyFormModal } from 'iron-man';
import { useTranslation } from 'react-i18next';
import './index.less';
import Dialog from '../Dialog';
import { isEmpty } from '@fe-util/common';
import i18n from '../../../i18n';
import React from 'react';
import { csatAPiDomain } from '../../../setting';
import useLoadingStore from "../../../store/useLoadingStore";

// import { MockData } from './mockData';

const SurveyModal = (props) => {
  const { refNo, submitSuccess } = props;
  const { setLoading } = useLoadingStore.getState();
  const { t } = useTranslation();
  const surveyCode = 'PreAuth';
  /**
   * 只允许中文，英文字母，空格 換行，数字，@ 符号，
   * 中英文逗号、中英文句号、中英文感叹号、中英文顿号、中英文小括号、中英文中括号、
   * 中英文大括号、中英文冒号、中英文双引号、中英文单引号、中英文问号、中英文百分号、中英文省略号、
   * ￥、$ 货币輸入
   */
  /* eslint-disable no-useless-escape */
  // const pattern =
  //   /^[\u4e00-\u9fa5a-zA-Z0-9@\s,，.。!！、（）()【】\[\]{}“”\"‘’\'？?%…\u00A5￥＄\$:：]*$/;
  // // /^[\u4e00-\u9fa5a-zA-Z0-9@\s,，.。!！、（）()【】\[\]{}“”\"‘’\'？?%…\u00A5￥＄\$:；;：]*$/; 包含分号的
  const rateCondition = 3; // 评分小于等于3时，显示备注框
  const defaultRate = 5; // 默认

  const [isOpen, setIsOpen] = useState(false);
  const [rate, setRate] = useState(defaultRate);
  const [isDisable, setIsDisable] = useState(false);
  const [setting, setSetting] = useState({});
  const [options, setOptions] = useState([]);
  const [remarkMax, setRemarkMax] = useState(200);
  const [textData, setTextData] = useState({
    title: t('translation:surveyForm.title'),
    surveyRateTips: t('translation:surveyForm.surveyRateTips'),
    textAreaPlaceholder: t('translation:surveyForm.textAreaPlaceholder'),
    submitText: t('translation:surveyForm.submitText'),
    // 以下这三个从数据中拿
    subTitle: '',
    surveyOptionTitle: '',
    surveyRemarkTitle: '',
  });
  const [formRules, setFormRules] = useState();

  const init = async () => {
    try {
      setLoading(true);
      /** 以下为真实请求 */
      await fetch(`${csatAPiDomain}/SurveyQuestion/GetCSATSurveySetting?surveyCode=${surveyCode}`, {
        method: 'GET',
        // headers: {
        //     'Authorization': `Bearer ${token}`
        // },
    }).then((response) => response.json()).then((data) => {
      setLoading(false);
      if (data.data) {
        // 成功查询到数据才弹窗，不然没有意义
        setIsOpen(true);
        setSetting(data.data);
        setSurveyForm(defaultRate, data.data);

        
      /** mock Data 调试用 */
      // const mockData = MockData;
      // // 成功查询到数据才弹窗，不然没有意义
      // setIsOpen(true);
      // setSetting(mockData.data);
      // setSurveyForm(rate, mockData.data);
      }
    });

 

    } catch (error) {
      setLoading(false);
      console.error('init CSATSurvey error: ', error);
    }
  };

  /**
   * 设置调查表单
   *
   * @param currentRate 当前评分
   * @param currentSetting 当前设置，可选参数，默认为 undefined
   */
  const setSurveyForm = (currentRate, currentSetting = undefined) => {
    const { question1, lowstar, highStar } = currentSetting || setting;
    let newTextData = {};
    let newOptions = [];
    let titleOption = {};
    let newQuestion3 = {};
    let newFormRules = [];


    if (currentRate <= rateCondition) {
      const { question2 = [], question3 = {} } = lowstar || {};
      titleOption = question2?.find((item) => item.filedType === 'TITLE');
      newQuestion3 = { ...question3 };
      const tagOption = question2?.filter(
        (item) => item.filedType === 'CHECKBOX'
      );
      newOptions = tagOption?.map((item) => ({
        label: i18n.language === 'en' ? item?.questionTitle : item?.questionChiTitle,
        value: item?.questionCode,
        groupNo: item?.groupNo,
      }));
      newFormRules = [
        {
          required: true,
          message: (
            <div className="iron-warn-text">
              <Icon name="alert_filled" />
              {t('translation:surveyForm.surveyOptionErrorMessage')}
            </div>
          ),
          name: 'surveyOption',
        },
        {
          required: true,
          message: (
            <div className="iron-warn-text align-left">
              <Icon name="alert_filled" />
              {t('translation:surveyForm.remarkErrorMessage')}
            </div>
          ),
          name: 'remark',
        },
        // {
        //   pattern: pattern,
        //   message: (
        //     <div className="iron-warn-text align-left">
        //       <Icon name="alert_filled" />
        //       {t('translation:surveyForm.remarkFailMessage')}
        //     </div>
        //   ),
        //   name: 'remark',
        // },
      ];
    } else {
      const { question2 = [], question3 = {} } = highStar || {};
      titleOption = question2?.find((item) => item.filedType === 'TITLE');
      newQuestion3 = { ...question3 };
      const tagOption = question2?.filter(
        (item) => item.filedType === 'CHECKBOX'
      );

      newOptions = tagOption?.map((item) => ({
        label: i18n.language === 'en' ? item?.questionTitle : item?.questionChiTitle,
        value: item?.questionCode,
        groupNo: item?.groupNo,
      }));
      newFormRules = [
        {
          required: true,
          message: (
            <div className="iron-warn-text">
              <Icon name="alert_filled" />
              {t('translation:surveyForm.surveyOptionErrorMessage')}
            </div>
          ),
          name: 'surveyOption',
        },
        {
          required: false,
          message: (
            <div className="iron-warn-text align-left">
              <Icon name="alert_filled" />
              {t('translation:surveyForm.remarkErrorMessage')}
            </div>
          ),
          name: 'remark',
        },
        // {
        //   pattern: pattern,
        //   message: (
        //     <div className="iron-warn-text align-left">
        //       <Icon name="alert_filled" />
        //       {t('translation:surveyForm.remarkFailMessage')}
        //     </div>
        //   ),
        //   name: 'remark',
        // },
      ];
    }
    newTextData = {
      title: t('translation:surveyForm.title'),
      surveyRateTips: t('translation:surveyForm.surveyRateTips'),
      textAreaPlaceholder: t('translation:surveyForm.textAreaPlaceholder'),
      submitText: t('translation:surveyForm.submitText'),
      subTitle:
      i18n.language === 'en'
          ? question1?.questionTitle
          : question1?.questionChiTitle,
      surveyOptionTitle:
      i18n.language === 'en'
          ? titleOption?.questionTitle
          : titleOption?.questionChiTitle,
      surveyRemarkTitle:
      i18n.language === 'en'
          ? newQuestion3?.questionTitle
          : newQuestion3?.questionChiTitle,
    };
    // setState 會導致渲染多次，所以批量处理更新
    setRate(currentRate)
    setTextData({ ...newTextData });
    setOptions(newOptions);
    setRemarkMax(newQuestion3?.inputMaxLength || 200);
    setFormRules([...newFormRules]);

  };

  const onHandleRateChange = (val) => {
    setSurveyForm(val);
  };

  const handleSubmit = async (formData) => {
    if (isEmpty(formData)) return;
    try {
      const { question1 = { surveyCode: '' }, lowstar, highStar } = setting;
      let newQuestion3 = {};

      if (formData?.rate <= rateCondition) {
        const { question3 = {} } = lowstar || {};
        newQuestion3 = { ...question3 };
      } else {
        const { question3 = {} } = highStar || {};
        newQuestion3 = { ...question3 };
      }
      const { surveyOption = [], remark } = formData;

      const surveyAnswers = surveyOption.map((item) => ({
        questionCode: item.value,
        questionAnswer: item.label,
        groupNo: item.groupNo,
      }));

      // question1
      surveyAnswers.push({
        questionCode: question1.questionCode,
        questionAnswer: String(formData?.rate),
        groupNo: question1.groupNo,
      });
      // question3
      surveyAnswers.push({
        questionCode: newQuestion3.questionCode,
        questionAnswer: remark,
        groupNo: newQuestion3.groupNo,
      });

      /**
       * 特定产品固定传参
       */
      const params = {
        surveyCode: question1?.surveyCode || surveyCode,
        refNo: refNo,
        channel: '',
        productCode: 'preauth',
        productName: 'preauth',
        category: 'Medical Insurance',
        eClaimItem: '',
        surveySubmitChannel: 'CorpWebSite',
        surveyAnswers: surveyAnswers,
      };

      await fetch(`${csatAPiDomain}/SurveyQuestion/SubmitCSATSurvey`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body:  JSON.stringify(params),
      });
      showMessage();
      if (submitSuccess) {
        submitSuccess();
      }
   
      } catch (error) {
        showMessage();
        console.error('submit CSATSurvey error: ', error);
      }
  };

  const showMessage = () => {
    setIsOpen(false);
    setIsDisable(true);
    Dialog({
      classNames: { all: 'bx-survey-form-thanks-modal' },
      title: t('translation:surveyForm.thanksTitle'),
      children: (
        <div>
         {t('translation:surveyForm.thanksText')}
        </div>
      ),
      okTxt: t('translation:surveyForm.thanksComplete'),
      onOk: () => {},
    });
  };

  useEffect(() => {
    let timeId = null; // 定時器 組件卸載時要清除
    // 1.5秒之後 打開意見評分的彈窗
    timeId = setTimeout(() => {
      init();
    }, 1500);
    return () => {
      clearTimeout(timeId);
    };
  }, []);

  return (
    <>
      <Button
        id="tss-payment-success-survey-btn"
        onClick={() => {
          init();
        }}
        disabled={isDisable}
        size='large'
      >
        {t('translation:surveyForm.openText')}
      </Button>
      <SurveyFormModal
        dialogProps={{
          classNames: {
            all: 'bx-survey-form-modal',
          },
          isOpen: isOpen,
          onClose: () => {
            setIsOpen(false);
          },
          isShowFoot: false,
        }}
        surveyFormProps={{
          className: 'bx-survey-form',
          formData: {
            rateNum: rate,
            surveyOptions: options,
            surveyRemark: '',
            remarkMax: remarkMax,
            rules: formRules,
          },
          textData: textData,
          onRateNumChange: onHandleRateChange,
          onSubmitSurveyForm: handleSubmit,
        }}
      />
    </>
  );
};

export default SurveyModal;
